import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { getHomePath, getDocTypePath, getRoutePath, getStoryPath, getDocPath, defDocType, removeTrailingSlash, ensureStartingSlash, getCategoryPath } from '@component-controls/core';

var getPageList = function getPageList(store) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defDocType;

  if (store) {
    return Object.keys(store.docs).reduce(function (acc, key) {
      var doc = store.docs[key];

      if (doc) {
        var _doc$type = doc.type,
            docType = _doc$type === void 0 ? defDocType : _doc$type;

        if (docType === type) {
          return [].concat(_toConsumableArray(acc), [doc]);
        }
      }

      return acc;
    }, []);
  }

  return [];
};

var getUniquesByField = function getUniquesByField(store, field) {
  return Object.keys(store.docs).reduce(function (acc, key) {
    var doc = store.docs[key];
    var value = doc[field];
    var values = Array.isArray(value) ? value : [value];
    values.forEach(function (v) {
      if (v !== undefined) {
        if (typeof acc[v] === 'undefined') {
          acc[v] = 0;
        }

        acc[v] = acc[v] = 1;
      }
    });
    return acc;
  }, {});
};

var getPageTabs = function getPageTabs(page) {
  if (page && page.tabs) {
    return Object.keys(page.tabs);
  }

  return [undefined];
};

var getDocPages = function getDocPages(store) {
  var _ref = (store === null || store === void 0 ? void 0 : store.config) || {},
      _ref$pages = _ref.pages,
      pages = _ref$pages === void 0 ? {} : _ref$pages,
      _ref$categories = _ref.categories,
      categories = _ref$categories === void 0 ? [] : _ref$categories;

  var docPaths = [];

  if (store) {
    var homePath = getHomePath(store);
    Object.keys(pages).forEach(function (type) {
      if (!categories.includes(type)) {
        var page = pages[type];
        var docType = type;
        var docHomePath = getDocTypePath(store, page.basePath);
        var docs = getPageList(store, docType);
        var tabs = getPageTabs(page);
        tabs.forEach(function (tab, tabIndex) {
          var route = tabIndex > 0 ? tab : undefined;
          docs.forEach(function (doc) {
            var _a, _b;

            var pagePath = getRoutePath(store, doc.route);

            if (pagePath !== homePath && pagePath !== docHomePath) {
              var stories = ((_a = page.sideNav) === null || _a === void 0 ? void 0 : _a.storyPaths) && ((_b = doc.stories) === null || _b === void 0 ? void 0 : _b.length) ? doc.stories : [undefined];
              stories.forEach(function (storyId) {
                var _getStoryPath = getStoryPath(storyId, doc, store, route),
                    path = _getStoryPath.path,
                    query = _getStoryPath.query;

                if (!docPaths.find(function (p) {
                  return p.path === path;
                })) {
                  var result = {
                    path: path,
                    type: docType,
                    docId: doc.title
                  };

                  if (storyId) {
                    result.storyId = storyId;
                  }

                  if (route) {
                    result.activeTab = route;
                  }

                  var lastModified = doc.dateModified ? new Date(doc.dateModified).toISOString() : undefined;

                  if (lastModified) {
                    result.lastModified = lastModified;
                  }

                  if (query) {
                    result.query = query;
                  }

                  docPaths.push(result);
                }
              });
            }
          });
        });
      } else {
        var cats = getUniquesByField(store, type);
        var catKeys = Object.keys(cats);
        catKeys.forEach(function (tag) {
          var path = getDocPath(type, {
            title: tag,
            componentsLookup: {}
          }, store);
          docPaths.push({
            path: path,
            type: type,
            category: tag
          });
        });
      }
    });
  }

  return docPaths;
};

var getHomePages = function getHomePages(store) {
  var _ref2 = (store === null || store === void 0 ? void 0 : store.config) || {},
      _ref2$pages = _ref2.pages,
      pages = _ref2$pages === void 0 ? {} : _ref2$pages,
      _ref2$categories = _ref2.categories,
      categories = _ref2$categories === void 0 ? [] : _ref2$categories;

  if (pages && store) {
    var docs = Object.keys(store.docs);
    var paths = Object.keys(pages).map(function (type) {
      var page = pages[type];
      var path = getDocTypePath(store, page.basePath);
      var typeDocs = docs.filter(function (key) {
        return type === (store.docs[key].type || defDocType);
      });

      if (!typeDocs.length) {
        return {
          type: type,
          path: ''
        };
      }

      var docId = page.indexHome ? undefined : docs.find(function (key) {
        var doc = store.docs[key];
        return removeTrailingSlash(ensureStartingSlash((doc === null || doc === void 0 ? void 0 : doc.route) || '')) === path;
      }) || docs.find(function (key) {
        return (store.docs[key].type || defDocType) === type;
      });
      var doc = docId ? store.docs[docId] : undefined;
      var docStories = (doc === null || doc === void 0 ? void 0 : doc.stories) || [];
      var storyId = docStories.length ? docStories[0] : undefined;
      var result = {
        type: type,
        path: path,
        docIndex: true
      };

      if (docId) {
        result.docId = docId;
      }

      if (storyId) {
        result.storyId = storyId;
      }

      var lastModified = (doc === null || doc === void 0 ? void 0 : doc.dateModified) ? new Date(doc === null || doc === void 0 ? void 0 : doc.dateModified).toISOString() : undefined;

      if (lastModified) {
        result.lastModified = lastModified;
      }

      return result;
    }).filter(function (_ref3) {
      var path = _ref3.path;
      return path;
    });
    var categoryPaths = categories.map(function (category) {
      var uniques = getUniquesByField(store, category);
      return {
        type: category,
        docIndex: true,
        path: Object.keys(uniques).length ? getCategoryPath(store, category) : ''
      };
    }).filter(function (_ref4) {
      var path = _ref4.path;
      return path;
    });
    return [].concat(_toConsumableArray(paths), _toConsumableArray(categoryPaths));
  }

  return [];
};

var getIndexPage = function getIndexPage(store) {
  if (store) {
    var docs = Object.keys(store.docs);
    var homePath = getHomePath(store);
    var homePageId = docs.find(function (key) {
      var doc = store.docs[key];
      return getRoutePath(store, doc.route) === homePath;
    });
    var homePage = homePageId ? store.docs[homePageId] : docs.length > 0 ? store.docs[docs[0]] : undefined;
    var docId = homePage === null || homePage === void 0 ? void 0 : homePage.title;
    var docStories = docId && store.docs[docId] ? store.docs[docId].stories || [] : [];
    var result = {
      path: homePath,
      type: (homePage === null || homePage === void 0 ? void 0 : homePage.type) || defDocType
    };
    var lastModified = (homePage === null || homePage === void 0 ? void 0 : homePage.dateModified) ? new Date(homePage === null || homePage === void 0 ? void 0 : homePage.dateModified).toISOString() : undefined;

    if (lastModified) {
      result.lastModified = lastModified;
    }

    var storyId = docStories.length ? docStories[0] : undefined;

    if (storyId) {
      result.storyId = storyId;
    }

    if (docId) {
      result.docId = docId;
    }

    return result;
  }

  return {
    type: defDocType,
    path: '/'
  };
};

var getRoutes = function getRoutes(store) {
  var routes = []; //home page

  var index = getIndexPage(store) || {};
  routes.push(index); //docs index pages

  var homePages = getHomePages(store);
  homePages.forEach(function (page) {
    routes.push(page);
  }); //document pages

  var docPages = getDocPages(store);
  docPages.forEach(function (page) {
    routes.push(page);
  });
  return routes;
};

var getSiteMap = function getSiteMap(store) {
  if (store) {
    var config = store.config.siteMap;
    var _store$config$siteUrl = store.config.siteUrl,
        siteUrl = _store$config$siteUrl === void 0 ? '' : _store$config$siteUrl;
    var sitePath = removeTrailingSlash(siteUrl);
    var siteMapPages = typeof config === 'object' ? config.pages : undefined;
    var pages = []; //home page

    var _ref5 = getIndexPage(store) || {},
        path = _ref5.path,
        lastModified = _ref5.lastModified;

    pages.push({
      path: path,
      priority: (siteMapPages === null || siteMapPages === void 0 ? void 0 : siteMapPages.home.priority) || 1,
      lastModified: lastModified
    });
    var homePages = getHomePages(store);
    homePages.forEach(function (_ref6) {
      var path = _ref6.path,
          lastModified = _ref6.lastModified;
      pages.push({
        path: path,
        priority: (siteMapPages === null || siteMapPages === void 0 ? void 0 : siteMapPages.index.priority) || 1,
        lastModified: lastModified
      });
    });
    var docPages = getDocPages(store);
    docPages.forEach(function (_ref7) {
      var path = _ref7.path,
          lastModified = _ref7.lastModified;
      pages.push({
        path: path,
        priority: (siteMapPages === null || siteMapPages === void 0 ? void 0 : siteMapPages.doc.priority) || 1,
        lastModified: lastModified
      });
    });
    var sitemap = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n  <urlset xmlns=\"http://www.sitemaps.org/schemas/sitemap/0.9\" xmlns:news=\"http://www.google.com/schemas/sitemap-news/0.9\" xmlns:xhtml=\"http://www.w3.org/1999/xhtml\" xmlns:mobile=\"http://www.google.com/schemas/sitemap-mobile/1.0\" xmlns:image=\"http://www.google.com/schemas/sitemap-image/1.1\" xmlns:video=\"http://www.google.com/schemas/sitemap-video/1.1\">\n  ".concat(pages.map(function (_ref8) {
      var path = _ref8.path,
          priority = _ref8.priority,
          lastModified = _ref8.lastModified;
      return "<url><loc>".concat(sitePath).concat(path, "</loc>").concat(lastModified ? "<lastmod>".concat(lastModified, "</lastmod>") : '', "<changefreq>daily</changefreq><priority>").concat(priority, "</priority></url>");
    }).join('\n'), "\n  </urlset>  \n  ");
    return sitemap;
  }

  return '';
};

export { getDocPages, getHomePages, getIndexPage, getPageTabs, getRoutes, getSiteMap, getUniquesByField };